'use strict';

const Content = require('data/domain/entity/content/index');
const ContentVersionFactory = require('data/domain/factory/content/version');

class ContentFactory {
    constructor(project) {
        this._project = project;
    }

    build(contentJSON) {
        return new Promise((resolve, reject) => {
            contentJSON._project = this._project;
            new ContentVersionFactory(this._project).build(contentJSON.latestVersion)
                .then(version => {
                    contentJSON.latestVersion = version.toJSON();
                    resolve(new Content(contentJSON));
                }, reject);
        });
    }
}

module.exports = ContentFactory;


// WEBPACK FOOTER //
// ./data/domain/factory/content/index.js